import React, { useEffect, useMemo, useState } from 'react';
import Iframe from 'react-iframe';
import Cookies from 'js-cookie';
import { pathToRegexp, match, compile } from 'path-to-regexp';
import { TokenKey, getApplicationUrl } from '@/const/serviceEnv';
import { useLocation } from 'react-router-dom';
import { useTabNavigate } from '@/hooks/useTabNavigate';

import theme from '@/theme';

interface WebviewProps {
  url?: string;
  needLGJtoken?: boolean;
  isSupplier?: boolean;
  width?: string;
  height?: string;
  needCenter?: boolean;
  parseQueryToMatch?: boolean;
}

const LiguanjiaUrl = getApplicationUrl('liguanjia');
const CardStoreUrl = getApplicationUrl('cardStore');

interface WebviewType {
  name: string;
  path: string;
  props: WebviewProps;
}



const webviewList: WebviewType[] = [
  {
    name: '代发订单管理',
    path: '/webview/dropship/list',
    props: {
      url: `${LiguanjiaUrl}/dispatch/batchHistory`,
    },
  },
  {
    name: '创建代发订单',
    path: '/webview/dropship/create',
    props: {
      url: `${LiguanjiaUrl}/dispatch/batchOrder`,
    },
  },
  {
    name: '下单成功通知',
    path: '/webview/dropship/order/notice',
    props: {
      url: `${LiguanjiaUrl}/dispatch/noticeMobile`,
    },
  },
  {
    name: '卡券管理',
    path: '/webview/plugin/coupon/list',
    props: {
      url: `${CardStoreUrl}/#/card-manager?isIframe=1&hideMenu=1&isFromWonderful=1&themeToken=green`,
      needLGJtoken: true,
      width: '1200px',
      height: '1000px',
      needCenter: true,
    },
  },
  {
    name: '卡券推广',
    path: '/webview/plugin/coupon/generalization',
    props: {
      url: `${CardStoreUrl}/#/card-extension?isIframe=1&hideMenu=1&isFromWonderful=1`,
      needLGJtoken: true,
      width: '1200px',
      height: '1000px',
      needCenter: true,
    },
  },
  {
    name: '卡券统一兑换',
    path: '/webview/plugin/coupon/exchange',
    props: {
      url: `${CardStoreUrl}/#/card-exchange?isIframe=1&hideMenu=1&isFromWonderful=1`,
      needLGJtoken: true,
      width: '1200px',
      height: '1000px',
      needCenter: true,
    },
  },
  {
    name: '挑选供应商商品',
    path: '/webview/lgj/goods/audit',
    props: {
      url: `${LiguanjiaUrl}/product_pick/self_goods_list`,
    },
  },
  {
    name: '商城订单',
    path: '/webview/lgj/mall/order/list',
    props: {
      url: `${LiguanjiaUrl}/esOrder/index`,
    },
  },
  {
    name: '订单导出',
    path: '/webview/lgj/mall/order/export',
    props: {
      url: `${LiguanjiaUrl}/OrderExport/index_web`,
    },
  },
  {
    name: '项目开发订单',
    path: '/webview/lgj/service/order/development/list',
    props: {
      url: `${LiguanjiaUrl}/team_develop/lists`,
    },
  },
  {
    name: '退货地址',
    path: '/webview/lgj/mall/setting/return/address',
    props: {
      url: `${LiguanjiaUrl}/team/rights_set`,
    },
  },
  {
    name: '订单确认方式',
    path: '/webview/lgj/mall/setting/order/confirm',
    props: {
      url: `${LiguanjiaUrl}/team/pay_type`,
    },
  },
  {
    name: '订单异常预警',
    path: '/webview/lgj/mall/setting/order/warning',
    props: {
      url: `${LiguanjiaUrl}/team/order_warning`,
    },
  },
  {
    name: '订单挂起通知',
    path: '/webview/lgj/mall/setting/order/suspend/warning',
    props: {
      url: `${LiguanjiaUrl}/team/order_pending_warning`,
    },
  },
  {
    name: '订单每日简报',
    path: '/webview/lgj/mall/setting/order/daily/report',
    props: {
      url: `${LiguanjiaUrl}/team_message/sms_notification_setting`,
    },
  },
  {
    name: '我的账户',
    path: '/webview/lgj/settlement/account',
    props: {
      url: `${LiguanjiaUrl}/finance/index`,
    },
  },
  {
    name: '商品账户充值',
    path: '/webview/lgj/settlement/account/recharge',
    props: {
      url: `${LiguanjiaUrl}/finance/recharge`,
    },
  },
  {
    name: '技术账户充值',
    path: '/webview/lgj/settlement/account/rechargeNewService',
    props: {
      url: `${LiguanjiaUrl}/finance/rechargeNewService`,
    },
  },
  {
    name: '商品交易汇总',
    path: '/webview/lgj/settlement/dealings/summary',
    props: {
      url: `${LiguanjiaUrl}/finance/finance_summary`,
    },
  },
  {
    name: '商品交易明细',
    path: '/webview/lgj/settlement/dealings/list',
    props: {
      url: `${LiguanjiaUrl}/finance/finance_detail`,
    },
  },
  {
    name: '对账单',
    path: '/webview/lgj/settlement/bill',
    props: {
      url: `${LiguanjiaUrl}/finance/finance_reconciliation`,
    },
  },
  {
    name: '商品发票',
    path: '/webview/lgj/settlement/purchase/invoice',
    props: {
      url: `${LiguanjiaUrl}/invoice/index?type=product`,
    },
  },
  {
    name: '运费发票',
    path: '/webview/lgj/settlement/freight/invoice',
    props: {
      url: `${LiguanjiaUrl}/invoice/index?type=freight`,
    },
  },
  {
    name: '技术发票',
    path: '/webview/lgj/settlement/service/invoice',
    props: {
      url: `${LiguanjiaUrl}/invoice/index?type=service`,
    },
  },
  {
    name: '索取发票',
    path: '/webview/lgj/settlement/service/doInvoice',
    props: {
      url: `${LiguanjiaUrl}/invoice/do_invoice`,
    },
  },
  {
    name: '查看开票记录',
    path: '/webview/lgj/settlement/service/reCoder',
    props: {
      url: `${LiguanjiaUrl}/invoice/recoder?type=service`,
    },
  },
  {
    name: '订单详情',
    path: '/webview/lgj/order/orderDetail/:id',
    props: {
      url: `${LiguanjiaUrl}/order/orderDetail/:id`,
    },
  },
  {
    name: '售后详情',
    path: '/webview/lgj/sale/view/:id',
    props: {
      url: `${LiguanjiaUrl}/sale/view/:id`,
    },
  },
  {
    name: '短信概览',
    path: '/webview/lgj/settlement/message/dashboard',
    props: {
      url: `${LiguanjiaUrl}/team_message/index`,
    },
  },
  {
    name: '购买短信',
    path: '/webview/lgj/settlement/message/buy',
    props: {
      url: `${LiguanjiaUrl}/team_message/buy`,
    },
  },
  {
    name: '短信签名申请',
    path: '/webview/lgj/settlement/message/signature/add',
    props: {
      url: `${LiguanjiaUrl}/message_sn/add`,
    },
  },
  {
    name: '短信签名管理',
    path: '/webview/lgj/settlement/message/signature/apply',
    props: {
      url: `${LiguanjiaUrl}/message_sn/lst`,
    },
  },
  {
    name: '商城短信签名列表',
    path: '/webview/lgj/settlement/message/signature/store',
    props: {
      url: `${LiguanjiaUrl}/team_message/store_list`,
    },
  },
  {
    name: '商城额度管理',
    path: '/webview/lgj/mall/credit/account',
    props: {
      url: `${LiguanjiaUrl}/finance/store_finance`,
    },
  },
  {
    name: '额度明细',
    path: '/webview/lgj/mall/credit/details',
    props: {
      url: `${LiguanjiaUrl}/finance/store_finance_detail`,
    },
  },
  {
    name: '开票信息维护',
    path: '/webview/lgj/mall/setting/invoice/info',
    props: {
      url: `${LiguanjiaUrl}/invoice/info`,
    },
  },
  {
    name: '收票地址设置',
    path: '/webview/lgj/mall/setting/invoice/address_list',
    props: {
      url: `${LiguanjiaUrl}/invoice/address_list`,
    },
  },
  {
    name: '开票记录',
    path: '/webview/lgj/mall/setting/invoice/recoder',
    props: {
      url: `${LiguanjiaUrl}/invoice/recoder?type=product`,
    },
  },
  {
    name: '订单数据',
    path: '/webview/lgj/data/order',
    props: {
      url: `${LiguanjiaUrl}/census/trade_data`,
    },
  },
  {
    name: '用户数据',
    path: '/webview/lgj/data/user',
    props: {
      url: `${LiguanjiaUrl}/census/user_data`,
    },
  },
  {
    name: '商品数据',
    path: '/webview/lgj/data/goods',
    props: {
      url: `${LiguanjiaUrl}/census/goods_data`,
    },
  },
  {
    name: '消息中心',
    path: '/webview/lgj/notice/list',
    props: {
      url: `${LiguanjiaUrl}/team_notice/lists`,
    },
  },
  {
    name: '代发选品',
    path: '/webview/lgj/dispatch/productList',
    props: {
      url: `${LiguanjiaUrl}/dispatch/productList`,
    },
  },
  {
    name: '已选商品',
    path: '/webview/lgj/dispatch/myProduct',
    props: {
      url: `${LiguanjiaUrl}/dispatch/myProduct`,
    },
  },
  {
    name: '批量下单',
    path: '/webview/lgj/dispatch/batchOrder',
    props: {
      url: `${LiguanjiaUrl}/dispatch/batchOrder`,
    },
  },
  {
    name: '下单历史',
    path: '/webview/lgj/dispatch/batchHistory',
    props: {
      url: `${LiguanjiaUrl}/dispatch/batchHistory`,
    },
  },
  {
    name: '变更通知',
    path: '/webview/lgj/dispatch/priceChange',
    props: {
      url: `${LiguanjiaUrl}/dispatch/priceChange`,
    },
  },
  {
    name: '下单通知',
    path: '/webview/lgj/dispatch/noticeMobile',
    props: {
      url: `${LiguanjiaUrl}/dispatch/noticeMobile`,
    },
  },
  {
    name: '下单通知',
    path: '/webview/lgj/dispatch/noticeMobile',
    props: {
      url: `${LiguanjiaUrl}/dispatch/noticeMobile`,
    },
  },
  {
    name: '下单通知',
    path: '/webview/lgj/dispatch/noticeMobile',
    props: {
      url: `${LiguanjiaUrl}/dispatch/noticeMobile`,
    },
  },
  {
    name: '老账户管理',
    path: '/webview/lgj/finance/history_team_finance_index',
    props: {
      url: `${LiguanjiaUrl}/finance/history_team_finance_index`,
    },
  },
  {
    name: '飞象企服发票',
    path: '/webview/lgj/invoice/history_index',
    props: {
      url: `${LiguanjiaUrl}/invoice/history_index`,
    },
  },
  {
    name: '分期商城',
    path: '/webview/lgj/apply_store/fq',
    props: {
      url: `${LiguanjiaUrl}/apply_store/fq`,
    },
  },
  {
    name: '3.0交易明细',
    path: '/webview/lgj/settlement/dealings/history/list',
    props: {
      url: `${LiguanjiaUrl}/finance/history_finance_detail`,
    },
  },
  {
    name: '3.0交易汇总',
    path: '/webview/lgj/settlement/dealings/history/summary',
    props: {
      url: `${LiguanjiaUrl}/finance/history_finance_summary`,
    },
  },
  {
    name: '虚拟商品编辑',
    path: '/webview/lgj/product/edit',
    props: {
      url: `${LiguanjiaUrl}/product/edit`,
      parseQueryToMatch: true,
    },
  },
  {
    name: '创建短信签名',
    path: '/webview/lgj/settlement/message/signature/add',
    props: {
      url: `${LiguanjiaUrl}/message_sn/add`,
    },
  },
  {
    name: '购买短信',
    path: '/webview/lgj/settlement/message/fctBuy',
    props: {
      url: `${LiguanjiaUrl}/team_message/fctBuy`,
    },
  },
];

const Webview: React.FC<{url?: string}> = ({url: initialUrl}) => {
  const [targetUrl, setTargetUrl] = useState('');

  const location = useLocation();
  const navigate = useTabNavigate();

  const { url, isSupplier, width, height, needCenter, needLGJtoken, parseQueryToMatch } =
    useMemo(() => {
      try {
       // 在webviewList中查找与当前路径匹配的配置项
       const _found = webviewList.find((item) => pathToRegexp(item.path).test(location.pathname));
       // 深拷贝找到的配置,避免修改原始对象
       const found = _found ? JSON.parse(JSON.stringify(_found)) : _found;
      // const found = webviewList.find((item) => item.path === location.pathname);

      if (!found) {
        navigate('/404', { replace: true });
      }else {
        // 解析路由参数
        const matcher = match(found.path, { decode: decodeURIComponent });
        const matchRes = matcher(location.pathname as string);

        if (matchRes && matchRes?.params && Object.keys(matchRes.params).length > 0) {
          // 如果有路由参数,将参数替换到url中
          const urlArr = found.props.url.split('://');
          const toPath = compile(urlArr?.[1], { encode: encodeURIComponent });
          const path = toPath(matchRes.params);
          found.props.url = `${urlArr?.[0]}://${path}`;
        }

        // 将location.search拼接到url后面
        found.props.url = `${found.props.url}${location.search}`;
      }

      if (found?.props.parseQueryToMatch) {
        found.props.url = `${found.props.url}${location.search}`;
      }

      return found?.props || {};
    } catch (error) {
      return { url: '' };
    }
    }, [location]);

  const formatQuery = (queryString: string) => {
    const queryPairs = queryString.slice(1).split('&');
    const values = queryPairs.map((pair) => pair.split('=')[1]);
    const path = `/${values.join('/')}`;
    return path;
  };

  const appendTokenToURL = (url: string) => {
    const token = Cookies.get(TokenKey);
    const liguanjiaToken = Cookies.get('liguanjia_member_token');
    const cardToken = Cookies.get('liguanjia_card_token');
    const productToken = Cookies.get('liguanjia_product_token');

    const queryParams = [
      `hideMenu=1`,
      `systemId=100012`,
      `colorPrimary=${encodeURIComponent(theme?.token?.colorPrimary || '')}`,
    ];

    if (needLGJtoken) {
      queryParams.push(
        `token=${liguanjiaToken}`,
        `liye_token=${token}`,
        `card_token=${cardToken}`,
        `product_token=${productToken}`,
      );
    } else if (isSupplier) {
      queryParams.push(`pangu_token=${token}`);
    } else {
      queryParams.push(`token=${token}`, `product_token=${productToken}`);
    }

    if (window.sessionStorage.getItem('postParam')) {
      const postParam: any = window.sessionStorage.getItem('postParam');
      queryParams.push(postParam);
      // 用完就清除
      window.sessionStorage.removeItem('postParam');
    }

    const queryString = queryParams.join('&');

    if (url.includes('?')) {
      if (parseQueryToMatch) {
        const query = url.split('?')[1];
        const match = formatQuery(`?${query}`);
        setTargetUrl(`${url.split('?')[0]}${match}?${queryString}`);
      } else {
        setTargetUrl(`${url}&${queryString}`);
      }
    } else {
      setTargetUrl(`${url}?${queryString}`);
    }
  };

  useEffect(() => {
    const handlePostMessage = (event: any) => {
      if (event?.data?.type === 'link' && event?.data?.data) {
        navigate(event?.data?.data);

        // 有一些跳转需要额外参数，格式：activeTab=2
        if (event?.data?.param) {
          window.sessionStorage.setItem('postParam', event?.data?.param);
        }
      }
    };

    if (url) {
      window.addEventListener('message', handlePostMessage, false);
      appendTokenToURL(url || '');
      return () => {
        window.removeEventListener('message', handlePostMessage);
      };
    }
  }, [url]);

  return (
    <div
      style={
        needCenter
          ? { display: 'flex', justifyContent: 'center', height: '100%' }
          : { height: '100%' }
      }
    >
      <Iframe url={initialUrl || targetUrl} width={width || '100%'} height={height || '100%'} frameBorder={0} />
    </div>
  );
};

export default Webview;
